import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getUserData } from '../redux/slices/users/usersSlice';
import { getMarketsList, listMarkets } from '../redux/slices/verticalMarkets/verticalMarketsSlice';
import { useDispatch } from '../redux/store';

export const useIsRemediation = (): boolean => {
  const dispatch = useDispatch();
  const user = useSelector(getUserData);
  const markets = useSelector(getMarketsList({}));

  useEffect(() => {
    if (!markets.result) {
      dispatch(listMarkets({}));
    }
  }, [dispatch, markets.result]);

  return useMemo(() => {
    const vmId = user?.organization?.vertical_market_id;
    return !!vmId && !!markets.result?.some((m) => m.id === vmId && m.market_name === 'Remediation');
  }, [user, markets]);
};
